import KendoMultiViewCalendarMixin from './KendoMultiViewCalendarMixin'

export default {
    name: 'kendo-multiviewcalendar',
    mixins: [ KendoMultiViewCalendarMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoMultiViewCalendar/index.js